// src/pages/mission/components/MissionHeader.jsx

import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { getColorClasses } from '../../themeConfig';

const MissionHeader = ({ mission, primaryColor, alertColor, onAbort }) => {
  return (
    <div className="flex items-center justify-between mb-8">
      <div>
        <div className="flex items-center gap-3 mb-2">
          <h1 className={`text-4xl font-bold ${getColorClasses(primaryColor)}`}>
            MISSION BRIEFING
          </h1>
          <div className={`${getColorClasses(alertColor, 'alertBg')} border ${getColorClasses(alertColor, 'alertBorder')} px-3 py-1 rounded-full text-sm font-bold ${getColorClasses(alertColor)}`}>
            {mission.tier?.toUpperCase() || 'TACTICAL'}
          </div>
        </div>
        <p className="text-xl text-gray-300 font-mono">
          {mission.name}
        </p>
      </div>
      <button
        onClick={onAbort}
        className="bg-gray-700 hover:bg-gray-600 px-6 py-3 rounded-lg font-bold flex items-center gap-2 transition-all"
      >
        <ChevronLeft size={20} />
        ABORT MISSION
      </button>
    </div>
  );
};

export default MissionHeader;